var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
/**
 * A component allows to hide/show element with it's height change
 */
var Grow = /** @class */ (function (_super) {
    __extends(Grow, _super);
    function Grow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            innerStyle: { maxHeight: '0' }
        };
        return _this;
    }
    Grow.prototype.componentDidUpdate = function (prevProps) {
        if (this.inner && prevProps.open !== this.props.open) {
            this.setState({
                innerStyle: {
                    maxHeight: this.props.open ? this.inner.offsetHeight + "px" : '0',
                }
            });
        }
    };
    Grow.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, _b = _a.timeout, timeout = _b === void 0 ? 300 : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
        var style = __assign(__assign({}, this.state.innerStyle), { transitionDuration: timeout / 1000 + "s" });
        return (React.createElement("div", { className: "madonna-grow " + className, style: style },
            React.createElement("div", { className: "madonna-grow-inner", ref: function (el) { return _this.inner = el || undefined; } }, children)));
    };
    return Grow;
}(React.Component));
export default Grow;
//# sourceMappingURL=Grow.js.map